import Vue from 'vue';
import Vuex from 'vuex';

export default class {
  constructor() {

    Vue.use(Vuex);

    const state = {
      cityOptions: [],
      propertyOptions: [],
      selectedCity: null,
      selectedProperty: null,
      submittedResults: [],
      showResults: false,
      loading: false,
      isInitialLoad: true,
      showError: false
    };

    const getters = {
      loading: ({ loading }) => loading,
      showResults: ({showResults}) => showResults,
      cityOptions: ({cityOptions}) => cityOptions,
      propertyOptions: ({propertyOptions}) => propertyOptions,
      selectedCity: ({selectedCity}) => selectedCity,
      selectedProperty: ({selectedProperty}) => selectedProperty,
      submittedResults: ({submittedResults}) => submittedResults,
      isInitialLoad: ({isInitialLoad}) => isInitialLoad,
      showError: ({showError}) => showError
    };

    const mutations = {
      setSelectedCity(state, value) {
        state.selectedCity = value;
      },
      setSelectedProperty(state, value) {
        state.selectedProperty = value;
      },
      setSubmittedResults(state, value) {
        state.submittedResults = value;
      },
      setShowResults(state, value) {
        state.showResults = value;
      },
      setLoading(state, value) {
        state.loading = value;
      },
      setCityOptions(state, options) {
        state.cityOptions = options;
      },
      setPropertyOptions(state, options) {
        state.propertyOptions = options;
      },  
      setIsInitialLoad(state, value) {
        state.isInitialLoad = value;
      },
      setShowError(state, value) {
        state.showError = value;
      }
    };

    const actions = {
      async fetchDropdownOptions({ commit }) {
        commit('setLoading', true);
        try {
          const response = await fetch('/api/officer-lookup/filter');
          const data = await response.json();
          commit('setPropertyOptions', data.properties);
          commit('setCityOptions', data.cities);
        } catch (error) {
          console.error('Error fetching dropdown options:', error);
        } finally {
          commit('setLoading', false);
        }
      },
      async submitForm({ commit }, { city, property }) {
        commit('setLoading', true);
        
        commit('setIsInitialLoad', false);

        this.state.selectedCity = city;
        this.state.selectedProperty = property;

        try {
          const payload = {
              city: state.selectedCity,
              propertyName: state.selectedProperty,
            };
  
          const response = await fetch('/api/officer-lookup/search', {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
              },
              body: JSON.stringify(payload),
          });
  
          const results = await response.json();
          
          const extractedResults = results.map(result => {
              return {
                  itemID: result.itemID,
                  propertyName: result.propertyName,
                  propertyNumber: result.propertyNumber,
                  city: result.city,
                  contactName: result?.chfaContact,
                  contactEmail: result?.person?.email ?? '',
                  contactPhone1: result?.person?.contact1Telephone ?? null,
                  contactPhone2: result?.person?.contact2Telephone ?? null,
                  contactPhone3: result?.person?.contact3Telephone ?? null,
                  contact1Label: result?.person?.contact1Label ?? null,
                  contact2Label: result?.person?.contact2Label ?? null,
                  contact3Label: result?.person?.contact3Label ?? null,
                  jobTitle: result?.person?.jobTitle ?? '',
                  contactFormLink: result?.person?.contactFormPage?.itemLinkUrl ?? null
              };
          });
  
          commit('setSubmittedResults', extractedResults);
          commit('setShowResults', extractedResults.length > 0);
          commit('setShowError', extractedResults.length === 0);
        } catch (error) {
          commit('setSubmittedResults', []);
          commit('setShowResults', false);
          console.error('Error submitting form:', error);
          commit('setShowError', true);
        } finally {
          commit('setLoading', false);
        }
      },
      clearForm({ commit }) {
        commit('setSelectedCity', "");
        commit('setSelectedProperty', "");
        commit('setSubmittedResults', []);
        commit('setShowResults', false);
        commit('setLoading', false);
        commit('setShowError', false);
      }
    };

    this.store = new Vuex.Store({
      state,
      getters,
      mutations,
      actions,
    });
  }
}
